import React from 'react';

/** Availability of paid image generation; uploads and saved candidates remain usable. */
export const ExerciseImageGenerationAvailability = React.createContext<boolean | 'checking'>(true);

/** Tracks manual picture requests above the saved exercise editor. */
export const ExerciseImageRequestActivity = React.createContext<(controlId: string, active: boolean) => void>(() => undefined);
